<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'VFileEditor',
  extends: compoment
}
</script>
